import {cx} from "@emotion/css";

import {isNotUndefined} from "@/shared/FunctionCore";
import {classCombinerFromPrefix} from "@/app/pages/upik/resources/RenderIdentifier";
import {IcompanyDataArray, SearchResultProps} from "@/app/pages/upik/resources/interfacesData";
import * as  SearchResultStyles from "@/app/pages/upik/styles/SearchResultStyles.module.scss";
import React from "react";
import { privateGermanURL, privateUsURL } from "@/app/pages/upik/resources/constant";


const classCombiner = classCombinerFromPrefix("850cb40c5e9711c2");

export interface ISearchResultProps extends SearchResultProps {
    companiesAPIdata: IcompanyDataArray;
    hereRedirectionLinkUrl:  string;
    isPrivatePage?: boolean;
    language?: string;
}

const SearchResult = ({
    companiesAPIdata,
    companyAddressLocalized,
    companyResultNoteLocalized,
    dunsNumberLocalized,
    editDetailsLocalized,
    hereRedirectionLinkUrl,
    isPrivatePage,
    searchResultsLocalized,
    topLocalized,
    language
}: ISearchResultProps): JSX.Element => {
    const companiesData = companiesAPIdata;
    const styles = SearchResultStyles;
    const topLabel = "Top";
    const searchResultsLabel = language === "de" ? "Suchergebnisse" : "Search Results";
    const DUNSNumberLabel = language === "de" ? "D-U-N-S® Nummer" : "D-U-N-S® Number";
    const companyAddressLabel = language === "de" ? "Unternehmensadresse" : "Company Address";
    const editDetailsLabel = language === "de" ? "Details bearbeiten" : "Edit details";
    const companyResultNoteLabel = language === "de" ? "Die Angaben sind nicht korrekt und Sie möchten Änderungen vornehmen?" : "The information is incorrect and you want to make changes?";
    
    return (
        <div className={cx(classCombiner(styles, "margin-left-3-5-em"))}>
            <div className={cx(classCombiner(styles, "title"))}>
                {topLocalized ?? topLabel}

                {" "}

                {companiesData.length}

                {" "}

                {searchResultsLocalized ?? searchResultsLabel}
            </div>

            <div className={cx(classCombiner(styles, "upik-search-result-paper"))}>
                {companiesData.map((company) => (
                    <div
                        className={cx(classCombiner(styles, "upik-search-result-item-card"))}
                        key={company.duns}>
                        <a
                            className={cx(classCombiner(styles, "company-title"))}
                        >
                            {company.primaryName}
                        </a>

                        <div
                            className={cx(classCombiner(styles, "detail"), classCombiner(styles, "marginTop"))}
                        >
                            {dunsNumberLocalized ?? DUNSNumberLabel}

                            :
                            {" "}

                            {company.duns}
                        </div>

                        <div
                            className={cx(classCombiner(styles, "detail"), classCombiner(styles, "marginTop"))}
                        >
                            {companyAddressLocalized ?? companyAddressLabel}

                            :

                            <p className={cx(classCombiner(styles, "paragraph"))}>
                                {company.companyAddress } {company.companyZipCode } {company.companyRegion}
                            </p>
                        </div>

                        <p
                            className={cx(classCombiner(styles, "paragraph"), classCombiner(styles, "marginTop"))}
                        >
                            {companyResultNoteLocalized ?? companyResultNoteLabel}
                        </p>

                        <div
                            className={cx(
                                "credit-link",
                                classCombiner(styles, "detail-link"),
                                classCombiner(styles, "marginTop")
                            )}
                        >
                            <a
                                href={
                                    isNotUndefined(isPrivatePage) && isPrivatePage ? (language === "de" ? `${privateGermanURL}?DUNS=${company.duns}` : `${privateUsURL}?DUNS=${company.duns}`) : hereRedirectionLinkUrl
                                }
                                rel="noreferrer"
                                target="_blank"
                            >
                                {editDetailsLocalized ?? editDetailsLabel}

                                <span className="chevron-right-arrow-blue" />
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export {SearchResult};
